import updatePreference from '@/repositories/Forms/updatePreference'

const updatePreferenceService = {
  async get(data: any) {
    return (await updatePreference.updatePreference()).post('/moengage-subscription-v2', data)
  }
}

export default updatePreferenceService
